<template>
  <div>
    <v-row no-gutters align="center">
      <v-spacer />
      <!-- Button show dialog create maintain -->
      <v-btn color="primary" @click="dialogCreateNotice = true"
        >新規作成</v-btn
      >
    </v-row>
    <!-- List maintain -->
    <v-layout class="row mx-1 mt-5" child-flex>
      <v-data-table
        :headers="headers"
        fixed-header
        :items="listNotice"
        :loading="loadingGetListNotice"
        :items-per-page.sync="pagination.maxResultCount"
        :page="pagination.page"
        loading-text="読み込み中。。。待ってください。"
        hide-default-footer
        class="elevation-1"
      >
        <!-- Status -->
        <template v-slot:item.type="{ item: { type } }">
          <!-- If status notice [PUBLISH/公開] -->
          <v-chip
            small
            color="#70C140"
            class="status-maintain"
            text-color="white"
            v-if="type == 'PUBLISH'"
          >
            {{ type | statusNotice }}
          </v-chip>
          <!-- If status UNPUBLISH [UNPUBLISH/非公開] -->
          <v-chip
            small
            color="#E0E0E0"
            class="status-maintain"
            v-if="type == 'UNPUBLISH'"
          >
            {{ type | statusNotice }}
          </v-chip>
          <!-- If status REMOVE [REMOVE/取り下げ] -->
          <v-chip
            color="#EE5F59"
            small
            text-color="white"
            v-if="type == 'REMOVE'"
            class="status-maintain"
          >
            {{ type | statusNotice }}
          </v-chip>
        </template>
        <!-- publish time -->
        <template v-slot:item.publish_time="{ item: { publish_time } }">
          {{ publish_time | dateTime }}
        </template>
        <!-- created time -->
        <template v-slot:item.unpublish_time="{ item: { created_at } }">
          {{ created_at | dateTime }}
        </template>
        <!-- remove time -->
        <template v-slot:item.remove_time="{ item: { remove_time } }">
          {{ remove_time | dateTime }}
        </template>
        <template v-slot:item.actions="{ item, item: { Id, type } }">
          <div class="d-flex justify-end">
            <!--  Edit -->
            <v-btn
              small
              color="#D81B60"
              outlined
              class="mr-3 text-button"
              @click="showDialogUpdate(item)"
              >確認</v-btn
            >
            <!--  Detele -->
            <v-btn
              :disabled="type != 'UNPUBLISH'"
              small
              color="error"
              @click="showDialogComfirmDelete(Id)"
              >削除</v-btn
            >
          </div>
        </template>
        <template v-slot:no-data>
          <div class="text-center">データがありません。</div>
        </template>
      </v-data-table>
    </v-layout>
    <v-row class="mx-1 mt-2">
      <strong class="mt-4 mr-2">表示件数</strong>
      <v-select
        class="max-width-1 mt-2"
        hide-details
        :items="recordsPage"
        v-model="pagination.maxResultCount"
        dense
        outlined
      />
      <v-spacer />
      <BasePagination
        v-if="listNotice.length > 0"
        class="mt-5"
        :pageCount="listNotice.length"
        :pageSize="pagination.maxResultCount"
        @changePage="(value) => (pagination.page = value)"
      />
    </v-row>
    <!-- Dialog create notice -->
    <DialogCreateNotice
      v-model="dialogCreateNotice"
      :data="listNotice"
      :key="`DialogCreateNotice-${keyDialogCreateNotice}`"
      @resetList="fetchListNotice"
    />
    <!-- Dialog update maintain -->
    <DialogUpdateNotice
      v-model="dialogUpdateNotice"
      :itemUpdate="itemUpdate"
      :data="listNotice"
      @resetList="fetchListNotice"
    />
    <!-- Dialog confirm delete -->
    <v-dialog v-model="dialogConfirmDelete" persistent max-width="350">
      <v-card>
        <v-card-title class="headline justify-center">
          <span>確認</span>
        </v-card-title>
        <v-card-text class="pb-0"> 削除します。よろしいですか </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            class="font-weight-bold"
            :loading="loadingDelete"
            @click="handleDeleteNotice"
            small
            >OK</v-btn
          >
          <v-btn @click="dialogConfirmDelete = false" small>キャンセル</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import mixin from "@/mixin";
import DialogCreateNotice from "./DialogCreateNotice";
import DialogUpdateNotice from "./DialogUpdateNotice";
import { getListNotice, deleteNotice } from "@/api/MasterData.api";
import BasePagination from "@/components/Pagination/BasePagination";
import vm from "@/main";
export default {
  mixins: [mixin.App],
  components: {
    DialogCreateNotice,
    DialogUpdateNotice,
    BasePagination,
  },
  data() {
    return {
      dialogCreateNotice: false,
      dialogUpdateNotice: false,
      dialogConfirmDelete: false,
      actionId: "",
      //   Header list maintain
      headers: [
        // Status
        { text: "状態", value: "type",align: "center" },
        // publish time
        { text: "配信日時", value: "publish_time" },
        // created time
        { text: "作成日時", value: "unpublish_time" },
        // Title
        { text: "タイトル", value: "title" },
        // Detail
        { text: "内容", value: "content" },
        // Action
        {
          text: "操作",
          value: "actions",
          width: "100px",
          align: "center",
        },
      ],
      //   List data
      listNotice: [],
      //   Loading get list
      loadingGetListNotice: false,
      //   Loading delete
      loadingDelete: false,
      //   key dialog create
      keyDialogCreateNotice: 0,
      //   item Update
      itemUpdate: {},
    };
  },
  async mounted() {
    await this.fetchListNotice();
  },
  filters: {
    statusNotice: function (val) {
      let status =
        // PUBLISH
        val == "PUBLISH"
          ? "配信成功"
          : // UNPUBLISH
          val == "UNPUBLISH"
          ? "配信待ち"
          : // REMOVE
            "配信失敗";
      return status;
    },
    dateTime: function (val) {
      const { $moment } = vm;
      if (!val) return "";
      return $moment.unix(val).format("YYYY年MM月DD HH:mm");
    },
  },
  watch: {
    dialogCreateNotice: function () {
      this.keyDialogCreateNotice++;
    },
    "pagination.maxResultCount": function () {
      this.pagination.page = 1;
    },
  },
  methods: {
    fetchListNotice: async function () {
      this.loadingGetListNotice = true;
      const { result } = await getListNotice().catch(this.$toast.error);
      this.loadingGetListNotice = false;
      if (!result) return;
      this.listNotice = result;
    },
    showDialogComfirmDelete: function (id) {
      this.dialogConfirmDelete = true;
      this.actionId = id;
    },
    showDialogUpdate: function (item) {
      console.log("item: ", item);
      this.itemUpdate = item;
      this.dialogUpdateNotice = true;
    },
    handleDeleteNotice: async function () {
      let params = {
        id: this.actionId,
      };
      this.loadingDelete = true;
      await deleteNotice(params)
        .then(() => {
          this.dialogConfirmDelete = false;
          this.fetchListNotice();
        })
        .catch(this.$toast.error);
      this.loadingDelete = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.status-maintain {
  min-width: 100px;
  font-weight: bold;
}
::v-deep .status-maintain span {
  margin: 0 auto;
}
</style>